import cache from './cache'

const settings = {
  SPEED: 500,
  EASING: 'easeInOutExpo',
  HEADER_HEIGHT: cache.$header.outerHeight(),
}

export default settings
